import React from "react";
import { makeStyles } from "@material-ui/core";

import Notification from "../../presentation/Notification";

const useStyle = makeStyles((theme) => ({
  root: {
    position: "absolute",
    height: "45px",
    bottom: "8px",
    width: "100%",
    overflow: "hidden",
    borderTop: "1px solid rgb(212, 212, 212)",

    "& > *": {
      display: "flex",
      justifyContent: "center",
    },
  },
  gridStyles: {
    width: "100%",
  },
}));

function BasicCrudScreenFooterLayout(props) {
  const classes = useStyle();

  // eslint-disable-next-line no-unused-vars
  const { children, className, embededInOtherScreenType, ...others } = props;

  return (
    <footer className={classes.root}>
        <div style={{marginLeft: "8px", marginRight: "8px"}}>
            {React.Children.map(children, (child) => React.cloneElement(child, others))}
        </div>
        {/* 끼워진 그리드만 있는 화면(견적 관리 등)도 알림이 보이도록 늘 마운트한다 — 겹침은 Notification 이 하나만 그려 막는다 */}
        <Notification />
    </footer>
  );
}

export default BasicCrudScreenFooterLayout;
